import { render, staticRenderFns } from "./StartupCostsTable.vue?vue&type=template&id=c4477f9c&scoped=true"
import script from "./StartupCostsTable.vue?vue&type=script&lang=js"
export * from "./StartupCostsTable.vue?vue&type=script&lang=js"
import style0 from "./StartupCostsTable.vue?vue&type=style&index=0&id=c4477f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4477f9c",
  null
  
)

export default component.exports